import type { 
  Parcours, 
  Mission, 
  Mascotte, 
  TypeParcours, 
  Solution,
  ParcoursWithRelations,
  MissionWithRelations
} from '../types/database';
import { parcoursData } from '../data/parcours';
import { missionsData } from '../data/missions';
import { mascottesData } from '../data/mascottes';
import { typesParcoursData } from '../data/typesParcours';
import { solutionsData } from '../data/solutions';

class DatabaseService {
  private parcours: Parcours[];
  private missions: Mission[];
  private mascottes: Mascotte[];
  private typesParcours: TypeParcours[];
  private solutions: Solution[];

  constructor() {
    // Charger les données statiques
    this.parcours = [...parcoursData];
    this.missions = [...missionsData];
    this.mascottes = [...mascottesData];
    this.typesParcours = [...typesParcoursData];
    this.solutions = [...solutionsData];
  }

  // Méthodes pour récupérer les données avec relations
  async getParcoursWithRelations(id: string): Promise<ParcoursWithRelations | null> {
    const parcours = this.parcours.find(p => p.id === id);
    if (!parcours) return null;

    const typesParcours = parcours.typeParcoursIds.map(typeId => 
      this.typesParcours.find(t => t.id === typeId)
    ).filter(Boolean) as TypeParcours[];

    const solution = this.solutions.find(s => s.id === parcours.solutionId);
    if (!solution) return null;

    const missions = await Promise.all(
      parcours.missionIds.map(async missionId => 
        await this.getMissionWithRelations(missionId)
      )
    );
    const validMissions = missions.filter(Boolean) as MissionWithRelations[];
    console.log(solution);
    
    return {
      ...parcours,
      typesParcours,
      solution,
      missions: validMissions
    };
  }

  async getParcoursWithRelationsBySlug(slug: string): Promise<ParcoursWithRelations | null> {
    const parcours = this.parcours.find(p => p.slug === slug);
    if (!parcours) return null;
    return await this.getParcoursWithRelations(parcours.id);
  }

  async getMissionWithRelations(id: string): Promise<MissionWithRelations | null> {
    const mission = this.missions.find(m => m.id === id);
    if (!mission) return null;

    const mascotte = this.mascottes.find(m => m.id === mission.mascotteId);
    const solution = this.solutions.find(s => s.id === mission.solutionId);
    const parcours = this.parcours.find(p => p.id === mission.parcoursId);

    if (!mascotte || !solution || !parcours) return null;

    return {
      ...mission,
      mascotte,
      solution,
      parcours
    };
  }

  async getAllParcours(): Promise<Parcours[]> {
    return [...this.parcours];
  }

  async getAllParcoursWithRelations(): Promise<ParcoursWithRelations[]> {
    const allParcours = await this.getAllParcours();
    const parcoursWithRelations = await Promise.all(
      allParcours.map(async p => await this.getParcoursWithRelations(p.id))
    );
    return parcoursWithRelations.filter(Boolean) as ParcoursWithRelations[];
  }
}

export const db = new DatabaseService();